import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import styled from "styled-components";
import Portrait from "../images/portrait/Portrait"; // Assuming Portrait is reusable
import Section from "../section/Section";

const Highlight = styled.span`
  background-color: #fff59d;
`;

const TextParagraph = ({
  content,
  gridTextSize = 12, // Default size for text grid
}) => {
  return (
    <Section>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} md={gridTextSize}>
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default TextParagraph;
